import {useEffect} from "react";

export default function usePushState(replace?: string) {
    useEffect(() => {
        window.history.pushState("", "", replace ?? "/");
    }, [replace]);
}
